import { render, staticRenderFns } from "./dialog_Inspection.vue?vue&type=template&id=3564606d&scoped=true&"
import script from "./dialog_Inspection.vue?vue&type=script&lang=js&"
export * from "./dialog_Inspection.vue?vue&type=script&lang=js&"
import style0 from "./dialog_Inspection.vue?vue&type=style&index=0&id=3564606d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564606d",
  null
  
)

export default component.exports